<template lang="pug">
.sheet-orders
  shChangePrintReturnAddress(v-for="change in changes" :change="change" :key="change.change" v-if="change.checked")
</template>

<script>
import shChangePrintReturnAddress from './ChangePrintReturnAddress.vue'

export default {
  name: 'PrintReturnAddressChanges',

  components: { shChangePrintReturnAddress },

  computed: {
    changes () {
      return this.$store.state.data.changes.data.docs
    }
  }
}
</script>

<style lang="stylus" scope>
.sheet-orders
  text-align left
  position relative
  background-color white

@media print
  .container, body
    padding 0
    margin 0
    background-color white
</style>



// WEBPACK FOOTER //
// src/components/pages/print/PrintReturnAddressChanges.vue